// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { addDays } from 'date-fns';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import Modal from './Modal';

export default class DateRange extends Modal {

    state = {
        startDate: new Date(),
        endDate: addDays(new Date(), 1)
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">

            <br />
            <h1>Pick a date range...</h1>

            <p>We'll only retrieve documents received within this time frame.</p>

            <div className="archives-date-picker">
                <DateRangePicker
                    ranges={[{
                        ...this.state,
                        key: 'selection'
                    }]}
                    months={2}
                    direction="horizontal"
                    editableDateInputs={true}
                    onChange={item => this.setState({ ...item.selection })}
                    // showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                />
            </div>

            <div style={{ clear: 'both', height: 20 }} />

            <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/calendar2.png')"
                }}
                onClick={() => this.props.select(this.state.startDate, this.state.endDate)}
            >Confirm date range</div>
            
        </div>);
    }

};